<!--
  ONE `<ng-content>`, captured in a template and rendered in exactly one of two branches.

  Sortable: inside a real `<button>`. Not sortable: BARE, with no button at all, so a screen reader
  navigating the table hears the column label and no control that does not exist ("Label, button,
  unavailable" was what a disabled button announced). Content projects into one slot only once, so
  the slot lives in `#content` and both branches outlet the same template; no call site passes a
  template. The bare wrapper is `display: contents` and adds no box.
-->
<ng-template #content><ng-content></ng-content></ng-template>
<!-- g15-unnamed-control: named by the projected column label, which the call site renders and a template read cannot see; the component warns at runtime when it is empty (warnIfUnnamed) -->
<button
  *ngIf="sortable; else bare"
  type="button"
  class="sort-header__button"
  (click)="activate()"
  (keydown)="onKeydown($event)"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</button>
<!-- Beside the button, never inside it: inside, the rank would become part of the button's name. -->
<ng-container *ngIf="sortable && rank">
  <span class="visually-hidden" *ngIf="rankDirection === 'asc'">{{ 'common.table.secondarySortAsc' | translate: { rank: rank } }}</span>
  <span class="visually-hidden" *ngIf="rankDirection !== 'asc'">{{ 'common.table.secondarySortDesc' | translate: { rank: rank } }}</span>
</ng-container>
<ng-template #bare>
  <span class="sort-header__bare"><ng-container *ngTemplateOutlet="content"></ng-container></span>
</ng-template>
